import { Button } from '@mui/material';

const YesNoButton = ({ type = 'button', handleClick, bgColor, title }) => {
	return (
		<Button
			type={type}
			variant="contained"
			onClick={handleClick}
			sx={{
				width: '6rem',
				lineHeight: '20px',
				borderRadius: '4px',
				color: 'common.white',
				transition: 'all 0.1s',
				bgcolor: bgColor ?? '#00914f',

				'&:hover': { bgcolor: bgColor ?? '#00914f', transform: 'scale(1.05)' },
			}}
		>
			{title}
		</Button>
	);
};

export default YesNoButton;
